import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

import { GoogleOAuthProvider } from '@react-oauth/google';




// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCK5Mcd2kGZ69Wcf2hfDjuQ0c9e-88zNLE",
  authDomain: "webschool26-b5dbd.firebaseapp.com",
  databaseURL: "https://webschool26-b5dbd-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "webschool26-b5dbd",
  storageBucket: "webschool26-b5dbd.appspot.com",
  messagingSenderId: "277578553905",
  appId: "1:277578553905:web:cd993271e21a977a8d9310",
  measurementId: "G-CDL0SFR90M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID} >
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
